import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/commons/app.service.ts' );

import {map, mergeMap, share, tap, flatMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, throwError} from 'rxjs';
import {of as observableOf} from 'rxjs/observable/of'
import {Account, User, Vasat} from 'vasat';
import {ObjectMeta, TicketRequest, WMSCreateRequest, WMSUrlMeta, WMSUrlRequest} from './models';

import {QMAP, QMAPService, ServerModel} from 'ng-qmap'
import {Title} from '@angular/platform-browser';
import { Dataset, TransformType, Folder, FourDService, Project } from '4d-mapper';

import { APIDialog } from './dialogs/explorer.dialogs';
import { MatDialog } from '@angular/material';
import { AlignBoundsDialog } from './dialogs/align-bounds/align-bounds.component';
import { AclService } from './acl/acl.service';
import { Constants } from './Constants';
import { environment } from '../../environments/environment';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';
import { UiManagerService } from '../xs/services/ui/ui-manager.service';

@Injectable()
export class AppService implements XsIdentityInterface {

  __ID = XsIdentityInterface.__init(this);


    debug:boolean = Constants.debug_off;

    private _loading:Observable<AppService>
    vasatInstance:any
    objectMetas:ObjectMeta[] = []
    myProfile:User
    accounts:Account[]

    curAccountObs:BehaviorSubject<Account> = new BehaviorSubject<Account>(null)
    accLoading:boolean      = false
    // Toolbar
    toolbar                 = {title:""}
    themes                  = [{name:"THEME.LIGHT",class:""},{name:"THEME.DARK",class:"dark-theme"}]
    curThemeClass:string    = ""
    languages               = [{name:'English',code:'en'},{name:'日本語',code:'ja'},{name:'中文',code:'zh'}]
    isSharedLogin:boolean

    //{name:'Español',code:'es'}]

    // user access / ACL

     // available roles
    roles: Set<string> = null;

    // this is the global access object we check if the current user role has access to stuff
    // allowed: Object = null;

    // site specific settings objects
    siteSettings:any

    // incoming language
    language:any = null;

    constructor( public V:Vasat, public fourD: FourDService, public titleService: Title, public permissions: AclService, public uiManager:UiManagerService ){

      DEBUG.log ( '/app/commons/app.service.ts' );

      V.registerClass(User);
      V.registerClass(Project);

      V.onLogout.subscribe(_ => {

            delete localStorage['last4d_token']
            delete localStorage['last4d_secret']

            this.myProfile      = null
            // Invalidate all vasat session
            this.V.invalidateSession()
            // Go to root page on logout
            //this.router.navigateByUrl(AppRoutes.AUTH)
        });
    }

    onReady():Observable<AppService>{
        
        if(this.accounts){
          if ( this.debug ) { console.log ( 'app.service :: onReady() observableOf'); }
          return observableOf(this)
        }
        else if(this._loading){
          if ( this.debug ) { console.log ( 'app.service :: onready() _loading'); }
          return this._loading
        }
        else{
          if ( this.debug ) { console.log ( 'app.service :: onReady() Vasat setup'); }
          return this._loading = this.V.onReady().pipe(mergeMap(v => {
              this.isSharedLogin = this.V.localSession() && !this.V.localSession().user

              // moved this here so share links dont die
              this.refreshMe().subscribe()
              
              return this.refreshData().pipe(
                  map(r => {
                      this._loading = null
                      if ( this.debug ) { console.log("app.service :: onReady() Vasat ready"); }
                      return this
                  }),)
          }),share())
        }
    }

    // let e = document.getElementById('loading-app'); if ( e ) { e.remove(); }

    refreshMe() {
        // console.log ( 'app.service :: refreshMe()');
        if ( this.debug ) { console.log("app.service :: refreshMe()"); }
        // fetch the api/me user object as well as Account list that this user belongs to
        return this.V.refreshMeUser().pipe(
            map(
                up => {
                    this.myProfile = up
                    // init Projects/Dashboard screen quick guides show/hide setting
                    if (!this.myProfile["hideProjectQuickGuidesOnStart"]) this.uiManager.toggleQuickGuidePopup("dashboard",true)
                    
                    if (!this.myProfile.json) this.myProfile.json = {}  // Simply make json field empty rather than null if it comes null from the server.
                },
                e => this.myProfile = null))
    }

    /**
     * Gets all the app data. The order of the requests matters
     */
    refreshData():Observable<any> {
        // console.log ( 'app.service :: refreshData()');
        return this.V.searchByObject(ObjectMeta).queryObservable().pipe(tap(o => this.objectMetas = o.items))
    }



  logout(){
        return this.V.logoutObservable().pipe(map(_ => {

        }))
    }

    getUserLocale(): String {
        if (navigator.languages != undefined)
            return navigator.languages[0];
        else
            return navigator.language;
    }

    /**
     * Loads the vasat instace config at '{host}/vasat'
     */
    loadInstanceConfig() {
        
      if ( this.debug ) { console.log ( 'app.service :: loadInstanceConfig()', this.V ); }

      var start = window.performance.now();

        return this.V.api("/4dinfo").pipe(map(config => {

          config['language'] = this.language;

          this.siteSettings = config;

            var link:any = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = config.fav_icon ||  this.V.config.host + "/4dinfo/favicon.png";
            document.getElementsByTagName('head')[0].appendChild(link);
          
            
            if (config.app_name) this.titleService.setTitle( config.app_name )
            this.vasatInstance = config;
            // console.log('siteSettings',this.siteSettings);
            if ( environment.production ) {
              this.curThemeClass = config.app_branding && config.app_branding?config.app_branding:''
            }

            var time = window.performance.now() - start;;

            if ( this.debug ) { 
              console.log ( 'app.service :: loadInstanceConfig() [Vasat] took '+time+' ms', config, environment );
            } 
        } ))
    }

    /**
     * Request email verification to register.
     */
    requestEmailRegistration(email:string) {
        return this.V.api("/access/register", "post", {email: email}).pipe(map(config => this.vasatInstance = config ))
    }

    /**
     * Returns the sufix for the given access group uid. Normally is "_users" or "_admins"
     * @param uid The access group uid to qeury
     */
    getAccessGroupSufix(accessGroupUid:string, accountUid:string) {
        return accessGroupUid.replace(accountUid, "")
    }


    showInputDialogForT(dialog:MatDialog, model: any, tt: TransformType) {
        let dialogRef = dialog.open(APIDialog, {
          minWidth:'350px',
    
          // height: '80%',
          data: {model: model, apis: [tt], title: 'TYPES.' + tt.uid}
        });
    
        return dialogRef.afterClosed()
      }
    
    
    startAdHoc(comp:MatDialog, d: Dataset, tt: TransformType, isNew: boolean, ttBatch: Folder = null) {
        return tt.apis.queryObservable().flatMap(res => {
    
          var onReady: Observable<any> = null

          // must do this here, if dialog box makes it, this method doesnt have access to reference
          if(!d.initParams)
            d.initParams = {}
          
          var model = d.initParams
          
          var next:Observable<boolean>
          if(tt.needsCRS){
              if(!d['unalignedBounds']){
                return throwError("Dataset " + d.name + " has no boundaries detected. The pre-processing window cannot start.")
              }


            let dialogRef = comp.open ( AlignBoundsDialog, {
                width: '80%',
                data: {dataset: d }
              });
          
              next = dialogRef.afterClosed()
          }
          else{
              next = of(true)
          }

          return next.pipe(flatMap(s => {
                
            if(!s) return

            //console.log(model)
            // when theres account specific ProcessorAPIs
            /* if (res.items.length) {
                // TODO: for now just do first one
                var api = res.items[0]
            
                onReady = api.needsInput || res.items.length > 1 ? this.showInputDialog(dialog, model, res.items, tt) : observableOf({
                api: api,
                model: {}
                })
        
            }*/
        
            // otherwise default transformType
            //  else {
                onReady = tt['needsInput'] || res.items.length > 1 ? this.showInputDialogForT(comp, model, tt) : observableOf({model: model})
            //}
        
        
            return onReady.pipe(flatMap(params => {
        
                if (!params) {
                if (isNew) d.destroyObservable().subscribe()
                return
                }
        
                if (ttBatch)
                params.model.batch_id = 'folder_' + ttBatch.id
        
                // when its an api specific tak that to end otherwise default
                //var extraURL = params.api ? ('/' + params.api.id) : ''
                d.initParams = params.model
                d.saveObservable()

                return d.applyTransform(tt, params.model)
        
            }))
            }))
        })
    }

    sendSupportTicket(ticketRequest:TicketRequest):Observable<any> {

      // If subject is empty then we populate it with a generic one
      if (!ticketRequest.subject) {
        var settings = { ...this.siteSettings, ...environment };
        var here = settings.app_name + ' ' + (settings.production?'Prod':'Beta') + '['+settings.app_version+']';

        var name = (this.fourD && this.fourD.activeUser) ? this.fourD.activeUser.name : "NA"

        ticketRequest.subject = 'Contact Form from "' + name + '" (in-app: '+ here +' )';
      }
      return this.V.api('/ticket/' + this.fourD.activeTeam.id, 'post', ticketRequest )
    }

    showContactUs():boolean {
      return !(this.siteSettings && this.siteSettings["hide_contact_form"])
    }

    apiDetectWmsUrl(req:WMSUrlRequest): Observable<WMSUrlMeta[]> {
      return this.V.api("/api/DetectURL", "post", req)
    }

    apiCreateWmsLayers(folder:Folder, req:WMSCreateRequest): Observable<WMSUrlMeta> {
      return this.V.api("/api/Folder/"+folder.id+"/CreateLayer", "post", req)
    }

}


@Injectable()
export class VasatQMAPService extends QMAPService{
    constructor(private service:AppService){
        super()
    }
    objectTypeQMap(objString:string):QMAP[]{
        return [{id:'name',type:'shorttext',title:'Name',required:true}]
    }
    objectsForQMap(qMap:QMAP,searchString?:string,superModel?:any):Observable<ServerModel[]>{
        var query = this.service.V.searchByObject(this.service.V.registeredClassForString(qMap.obj_type))
        if(searchString && qMap.filter){
          query =  query.complexQuery({
            op:'and',
            items:[
              qMap.filter,
              {
                op:'like',
                col:'name',
                val:'~' + searchString + '~'
              }
            ]
          })
        }
        else if(qMap.filter){
          query =  query.complexQuery(qMap.filter)
        }
        else if(searchString)
            query = query.contains('name',searchString)
        
        return query.queryObservable().pipe(
            map(i => i.items)
        )
    }
    isModel(obj:any):boolean{
        return !!obj && obj.toJSON
    }
    findCachedModel(qmap:QMAP,id:number):ServerModel{
        return this.service.V.findCached(qmap.obj_type,id)
    }
    makeModel(qmap:QMAP):ServerModel{
        var clazz = this.service.V.registeredClassForString(qmap.obj_type)
        return new clazz(this.service.V)
    }
    canWrite(sm:ServerModel):boolean{
        return sm.permissions?sm.permissions.find(p => 'api_update'):true
    }
    canDelete(sm:ServerModel):boolean{
        return sm.permissions?sm.permissions.find(p => 'api_delete'):false
    }
    absURL(m:ServerModel,s:string){
        return m.file(s) + '?access_token=' + this.service.V.token
    }
}
